<sbnb-confetti #confetti></sbnb-confetti>

<ng-container [ngSwitch]="pageLoadingState$ | async">
  <ng-container *ngSwitchCase="LoadingState.Pending">
    <div fxLayout class="sbnb-onboarding" style="margin-bottom: 24px; align-items: center; justify-content: center">
      <mat-spinner fxLayout fxLayoutAlign="center" [diameter]="30"></mat-spinner>
    </div>
  </ng-container>

  <ng-container *ngSwitchCase="LoadingState.Success">
    <ng-container *ngIf="!isMobile"><ng-template [ngTemplateOutlet]="desktopContent"></ng-template></ng-container>
    <ng-container *ngIf="isMobile"><ng-template [ngTemplateOutlet]="mobileContent"></ng-template></ng-container>
  </ng-container>

  <ng-container *ngSwitchCase="LoadingState.Error">
    <ng-container *ngIf="featureConfig && rules; else error">
      <ng-container *ngIf="!isMobile"><ng-template [ngTemplateOutlet]="desktopContent"></ng-template></ng-container>
      <ng-container *ngIf="isMobile"><ng-template [ngTemplateOutlet]="mobileContent"></ng-template></ng-container>
    </ng-container>
  </ng-container>
</ng-container>

<ng-template #desktopContent>
  <section class="sbnb-onboarding two-column" *ngIf="featureConfig && rules">
    <sbnb-signup-header></sbnb-signup-header>

    <article class="main">
      <ng-template [ngTemplateOutlet]="messagingRules"></ng-template>
    </article>
    <article class="column" style="margin-left: 100px; margin-right: 10px">
      <ng-template [ngTemplateOutlet]="conversationSimulator"></ng-template>
    </article>
  </section>
</ng-template>

<ng-template #mobileContent>
  <sbnb-signup-header></sbnb-signup-header>

  <swiper-container
    slides-per-view="1"
    navigation="true"
    pagination="true"
    pagination-clickable="true"
    keyboard-enabled="true"
    class="signup-messaging-rules-swiper">
    <swiper-slide>
      <div class="swiper-slide-container">
        <section class="sbnb-onboarding one-column">
          <article class="column">
            <ng-template [ngTemplateOutlet]="messagingRules"></ng-template>
          </article>
        </section>
      </div>
    </swiper-slide>
    <swiper-slide>
      <div class="swiper-slide-container">
        <section class="sbnb-onboarding one-column">
          <article class="column">
            <ng-template [ngTemplateOutlet]="conversationSimulator"></ng-template>
          </article>
        </section>
      </div>
    </swiper-slide>
  </swiper-container>
</ng-template>

<ng-template #messagingRules>
  <header>
    <h2 class="nomargin">Let's start saving your valuable time</h2>
  </header>

  <section class="content">
    <p class="menu-subtitle">
      Hospitable hosts automate 90% of their guest messaging. Start with the basics by activating these common
      touchpoints.
    </p>

    <div fxFlex *ngFor="let rule of ruleKeys">
      <div fxLayout fxLayoutAlign="start center" fxLayoutGap="24px">
        <mat-slide-toggle [(ngModel)]="rules[rule].isEnabled" (ngModelChange)="toggleRule($event, rule)">
          <strong>{{ rule }}</strong>
        </mat-slide-toggle>
        <ng-container *ngIf="rules[rule].label">
          <span class="card__collapsed-helper-text card__collapsed-text">
            {{ rules[rule].label }}
          </span>
        </ng-container>
        <ng-container *ngIf="!rules[rule].label">
          <span *ngIf="!rules[rule].isEnabled" class="card__collapsed-helper-text card__collapsed-text">
            + Save {{ rules[rule].hoursSaved }} hours
          </span>
          <span *ngIf="rules[rule].isEnabled" class="card__collapsed-text">
            Saved {{ rules[rule].hoursSaved }} hours
          </span>
        </ng-container>
      </div>
    </div>

    <ng-container *ngIf="activeCtas">
      <div *ngIf="activeCtas.primary" class="primary-cta-container">
        <sbnb-button
          [loading]="savingLoadingState === LoadingState.Pending"
          label="{{ activeCtas.primary.label() }}"
          [type]="activeCtas.primary.button ? activeCtas.primary.button : 'primary'"
          (clicked)="activeCtas.primary.action()"
          [fullWidth]="true"></sbnb-button>
      </div>

      <div *ngIf="activeCtas.secondary" class="secondary-cta-container">
        <sbnb-button
          label="{{ activeCtas.secondary.label() }}"
          [type]="'text'"
          [labelColor]="'#ED3C6A'"
          (clicked)="activeCtas.secondary.action()"
          [fullWidth]="true"></sbnb-button>
      </div>
    </ng-container>
  </section>
</ng-template>
<ng-template #conversationSimulator>
  <sbnb-progress-bar-simple [progress]="(totalHoursSaved / potentialTotalHoursSaved) * 100">
    <div class="progress-bar__content">
      <div class="progress-bar__title">
        {{ totalHoursSaved + ' / ' + potentialTotalHoursSaved + ' hours saved' }}
      </div>
      <div class="progress-bar__subtitle">
        Time saved every month
        <sbnb-icon
          [matTooltip]="
            'Hospitable calculates this value based on the number of properties you manage and the channels you have listed your properties on.'
          "
          icon="time"
          class="shrink-0 text-night"></sbnb-icon>
      </div>
    </div>
  </sbnb-progress-bar-simple>
  <sbnb-conversation-simulator
    [conversation]="activeConversation"
    (clickedEmbeddedLink)="enableAllRules()"
    [senderInitials]="getHostInitials()"
    [showNewMessageInput]="activeRuleCount === 0"
    [newMessageHint]="
      activeRuleCount === 0
        ? 'Send a manual reply, or &nbsp; <span class=\'clickable embedded-link\'>activate automatic replies </span>'
        : 'Message Preview - Edit Later'
    "></sbnb-conversation-simulator>
</ng-template>

<ng-template #error>
  <div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="24px">
    <div>
      <svg width="90" height="82" viewBox="0 0 90 82" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M2.47656 42.3789L40.9009 3.92191C42.0504 2.77921 43.607 2.14019 45.2278 2.14554C46.8486 2.15089 48.4009 2.80016 49.5429 3.95042L87.9998 42.3789"
          stroke="#E5E2E9"
          stroke-width="4"
          stroke-linecap="round"
          stroke-linejoin="round" />
        <path
          d="M75.7819 30.169V79.0313H14.6938V30.1487"
          stroke="#E5E2E9"
          stroke-width="4"
          stroke-linecap="round"
          stroke-linejoin="round" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M33 43C33 44.6569 31.6569 46 30 46C28.3431 46 27 44.6569 27 43C27 41.3431 28.3431 40 30 40C31.6569 40 33 41.3431 33 43ZM63 43C63 44.6569 61.6569 46 60 46C58.3431 46 57 44.6569 57 43C57 41.3431 58.3431 40 60 40C61.6569 40 63 41.3431 63 43ZM37.9152 59.8545C37.1972 60.2678 36.2801 60.0209 35.8668 59.3029C35.4534 58.585 35.7004 57.6679 36.4183 57.2546C39.3867 55.5455 47.0985 53.4341 55.4995 57.6005C56.2417 57.9686 56.5449 58.8686 56.1768 59.6108C55.8088 60.353 54.9087 60.6562 54.1666 60.2882C46.8001 56.6348 40.1545 58.5651 37.9152 59.8545Z"
          fill="#D0CDD4" />
      </svg>
    </div>
    <h2>Oops, an error has occurred</h2>
  </div>
</ng-template>
